import { Component, OnInit } from '@angular/core';
import { URL_DOCS } from 'src/app/config/config';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { CustomerService } from 'src/app/services/customer.service';
declare var $: any;

@Component({
  selector: 'app-admin-tips-login',
  templateUrl: './admin-tips-login.component.html',
  styleUrls: ['./admin-tips-login.component.css']
})
export class AdminTipsLoginComponent implements OnInit {

  URL_DOCS = URL_DOCS;
  tipSelected: any = [];
  isEdit = false;
  isLoading = false;
  modalActivo: 'crear' | 'editar' | null = null;

  nuevoTip = {
    titulo: '',
    descripcion: '',
    fechaFrom: '',
    fechaTo: '',
    numero: null,
    con_info_type: 3,
    is_global: false,
    client_id: null,
  };

  numeros: number[] = Array.from({ length: 10 }, (_, i) => i);
  numeroSeleccionado: number | null = null;

  errores: { [key: string]: boolean } = {};

  public listCustomers = [{ id: 0, name: '' }];
  selectedCustomerId: number | null = null;

  tipsList: any[] = [];      // acá dejas lo que viene de la API
  tipsFiltered: any[] = []; // esto es lo que pintas en la tabla


  constructor(
    public mantenedorService: MantenedorService,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this.getCustomers();
    this.getTipsLogin();
  }

  includeGlobals = true;

  applyFilter(): void {
    if (!this.selectedCustomerId) {
      this.tipsFiltered = [...this.tipsList];
      return;
    }
    //Solo globales
    //this.tipsFiltered = this.tipsList.filter(ad =>
    //  Number(ad?.con_info_cus_id) === Number(this.selectedCustomerId)
    //);

    //globales y del cliente
    this.tipsFiltered = this.tipsList.filter(ad => {
      const isCustomer = Number(ad?.con_info_cus_id) === Number(this.selectedCustomerId);
      const isGlobal = ad?.is_global === true;
      return isCustomer || (this.includeGlobals && isGlobal);
    });
  }

  private validarCamposObligatorios(campos: string[], datos: any): boolean {
    this.errores = {};
    let valido = true;

    for (const campo of campos) {
      const valor = datos[campo];

      if (!valor || valor.toString().trim() === '') {
        this.errores[campo] = true;
        valido = false;
      }
    }

    if (!valido) {
      setTimeout(() => {
        this.errores = {};
      }, 5000);
    }

    return valido;
  }

  getTipsLogin() {
    this.isLoading = true;
    let conInfoType = 3; //Login
    this.mantenedorService.getTips(conInfoType).then((data: any) => {
      this.tipsFiltered = data.data
      this.tipsList = data.data
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

  clickTipsLogin(tips) {
    this.tipSelected = tips;
  }
  editTip() {
    this.isEdit = true;
    this.modalActivo = 'editar';
  }
  cancelEditTip() {
    this.isEdit = false;
  }

  saveTip() {
    //console.log('Tips a guardar:', this.nuevoTip); // Para depurar

    const camposRequeridos = ['titulo', 'descripcion'];
    if (!this.validarCamposObligatorios(camposRequeridos, this.nuevoTip)) {
      return;
    }

    this.isLoading = true;
    this.modalActivo = 'crear';

    this.mantenedorService.saveTips(this.nuevoTip).then((res: any) => {
      // console.log('Correcto');

      this.nuevoTip = { titulo: '', descripcion: '', fechaFrom: '', fechaTo: '', numero: null, con_info_type: 3, is_global: false, client_id: null };
      this.isEdit = false;
      this.isLoading = false;
      this.modalActivo = null;
      
      
      // ✅ Cierra el modal con jQuery
      ($('#crearTipsLogin') as any).modal('hide');
      
      this.getTipsLogin();

    }).catch((error: any) => {
      console.log(error);
    });
  }

  updateTip() {
    //console.log('Tips a modificar:', this.tipSelected); // Para depurar

    const camposRequeridos = ['con_info_title', 'con_info_description'];
    if (!this.validarCamposObligatorios(camposRequeridos, this.tipSelected)) {
      return;
    }

    this.isLoading = true;

    this.mantenedorService.updateTips(this.tipSelected).then((res: any) => {
      // console.log('Correcto');
      
      this.isEdit = false;
      
      this.isLoading = false;
      this.modalActivo = null;
      
      ($('#visualizarTipsLogin') as any).modal('hide');
      
      this.getTipsLogin();

    }).catch((error: any) => {
      console.log(error);
    });
  }

  async getCustomers(){
    await this.customerService.getListCustomer().then((data: any) => {
      this.listCustomers = data.datos.data;
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

}
